/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamListForItemRepositoryResponsePaginatedResponse } from "../types/ExamListForItemRepositoryResponsePaginatedResponse.ts";
import { examListForItemRepositoryResponseSchema } from "./examListForItemRepositoryResponseSchema.ts";

export const examListForItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => examListForItemRepositoryResponseSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<ExamListForItemRepositoryResponsePaginatedResponse>;
